import { template as template_b28453df4bdf4fa580cf874dd41d6cc1 } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import BsModal from 'eflex/components/bs-modal';
import { t } from 'ember-intl';
export default template_b28453df4bdf4fa580cf874dd41d6cc1(`
<BsModal
  @open={{@open}}
  @onHidden={{@onHidden}}
  class="standard-popover danger test-jem-invalid-popover"
as |modal|>
  <div class="side-panel">
    <i class="eflex-icon danger"></i>
  </div>
  <modal.header>
    {{t (concat @messagePrefix ".header")}}
  </modal.header>
  <modal.body>
    <div class="main-panel ms-5">
      <div class="jem-alert-body ms-2">
        {{t (concat @messagePrefix ".text")}}
      </div>
    </div>
  </modal.body>
</BsModal>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
